import moment from 'moment';

const csvTemplate = {
  rows: [
    ['NAME', 'RADIUS', 'ADDRESS', 'LAT', 'LON'],
    ['MediaJel', '50', '1601 N Main St Suite', '14.7980323', '121.0449656'],
  ],
  templateName: 'MJ_GeoTarget_Template',
};

const kpiDefaultOptions = [
  {
    key: 'transactions',
    kpi: 'Transactions',
  },
  {
    key: 'signups',
    kpi: 'Sign-Ups',
  },
  {
    key: 'sessions',
    kpi: 'Sessions',
  },
];

const lineItemsDefaultValue = [
  {
    name: 'Line Item 1',
    startDate: moment(),
    endDate: moment().add(2, 'days'),
    budgetTotal: 0,
    budgetPercentage: 100,
    cpm: 7,
    regionGroups: [],
    targetingGroups: [],
    targetingType: null,
    targetingRegions: [],
    targetingLocations: [],
    targetingCountries: null,
    audienceType: null,
    firstPartyDataAudiences: [],
    adGroup: null,
  },
];

export const CampaignConfig = {
  csvTemplate,
  kpiDefaultOptions,
  lineItemsDefaultValue,
};
